import { getWrappedTextStyles, sharedTypographyStyles } from '../FinancialInfoBody.styles';

export const wrappedStyles = {
  ...getWrappedTextStyles(2),
  ...sharedTypographyStyles,
};

export const currencyStyles = {
  textAlign: 'right',
  width: '100%',
  ...sharedTypographyStyles,
};
